import * as React from 'react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Badge from '@mui/material/Badge'
import MenuItem from '@mui/material/MenuItem'
import Menu from '@mui/material/Menu'
import MenuIcon from '@mui/icons-material/Menu'
import NotificationsIcon from '@mui/icons-material/Notifications'
import AutoCompleteSearchBar from '../commonUIComponents/AutoCompleteSearchBar'
import { Divider, Drawer, Grid, List, ListItemIcon } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import LOGO_LARGE from '../../images/redditlike_logo_l.png'
import LOGO_SMALL from '../../images/redditlike_logo_s.png'
import { AdminList, BasicList, CommunityList } from '../commonUIComponents/NavigationList'
import communityService from '../../services/communityService'
import { useContext, useEffect, useState } from 'react'
import notificationService from '../../services/notificationService'
import { useSnackbar } from 'notistack'
import { AuthTokenContext } from '../contexts/AuthTokenContext'
import { UserInfoContext } from '../contexts/UserInfoContext'
import { NotificationContext } from '../contexts/NotificationContext'
import AddIcon from '@mui/icons-material/Add'
import { ActiveAvatar, UserAvatar } from '../commonUIComponents/CustomAvatar'
import SearchIcon from '@mui/icons-material/Search'
import LoginIcon from '@mui/icons-material/Login'
import FaceOutlinedIcon from '@mui/icons-material/FaceOutlined'
import { Logout, Settings } from '@mui/icons-material'
import NotificationListItem from '../commonUIComponents/NotificationListItem'
import CreateCommunityPage from '../pageComponents/CreateCommunityPage/CreateCommunityPage'

const Header = ({ onLogout }) => {
  const { authToken } = useContext(AuthTokenContext)
  const { userInfo } = useContext(UserInfoContext)
  const { unreadNotificationCount, setUnreadNotificationCount } = useContext(NotificationContext)

  const { enqueueSnackbar } = useSnackbar()
  const [openCreateCommunityModal, setOpenCreateCommunityModal] = useState(false)
  const [loading, setLoading] = useState(true)
  const [communities, setCommunities] = useState()
  const [notifications, setNotifications] = useState()

  const [openDrawer, setOpenDrawer] = React.useState(false)
  const [tooltipAnchorEl, setTooltipAnchorEl] = React.useState(null)
  const openTooltip = Boolean(tooltipAnchorEl)
  const [notificationAnchorEl, setNotificationAnchorEl] = React.useState(null)
  const openNotificationMenu = Boolean(notificationAnchorEl)

  const navigate = useNavigate()

  const fetchCommunities = () => {
    communityService.fetchCommunities()
      .then(res => setCommunities(res))
      .catch(err => console.log(err))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchCommunities()
  }, [])

  const fetchNotifications = () => {
    notificationService.fetchNotifications(0, 4)
      .then(res => {
        setNotifications(res.notifications)
        setUnreadNotificationCount(res.unread)
      })
      .catch(err => enqueueSnackbar(err, { variant: 'error' }))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (authToken) {
      setLoading(true)
      fetchNotifications()
    }
  }, [authToken, unreadNotificationCount, userInfo])

  const openNotificationMenuHandler = event => setNotificationAnchorEl(event.currentTarget)

  const closeNotificationMenuHandler = () => setNotificationAnchorEl(null)

  const openUserMenuHandler = event => setTooltipAnchorEl(event.currentTarget)

  const closeUserMenuHandler = () => setTooltipAnchorEl(null)

  const createCommunityModalOpenHandler = () => setOpenCreateCommunityModal(true)

  const createCommunityModalCloseHandler = () => setOpenCreateCommunityModal(false)

  const logoutHandler = () => {
    onLogout()
    navigate('/home')
    enqueueSnackbar('Successfully logged out!', { variant: 'success' })
  }

  const deleteNotificationHandler = () => {
    fetchNotifications()
  }

  const LogoWithSideNavBar = () => {
    return (
      <>
        <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
          <IconButton aria-label="home" component={Link} to={'/home'}>
            <img src={ LOGO_LARGE } alt="logo" width={140} height={25} />
          </IconButton>
        </Box>
        <Box sx={{ display: { xs: 'none', md: 'block', lg: 'none' } }}>
          <IconButton aria-label="home" onClick={() => setOpenDrawer(true)}>
            <MenuIcon />
          </IconButton>
          <IconButton aria-label="home" component={Link} to={'/home'}>
            <img src={ LOGO_LARGE } alt="logo" width={140} height={25} />
          </IconButton>
          <SideNavDrawer />
        </Box>
        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
          <IconButton aria-label="home" onClick={() => setOpenDrawer(true)}>
            <MenuIcon />
          </IconButton>
          <IconButton aria-label="home" component={Link} to={'/home'}>
            <img src={ LOGO_SMALL } alt="logo" width={30} height={24} />
          </IconButton>
          <SideNavDrawer />
        </Box>
      </>
    )
  }

  const SideNavDrawer = () => {
    return (
      <Drawer open={openDrawer} onClose={() => setOpenDrawer(false)}>
        <Box sx={{ width: 250 }} role="presentation" onClick={() => setOpenDrawer(false)}>
          <BasicList/>
          {authToken
            ? (
              <>
                <CommunityList communities={communities} createCommunityModalOpenHandler={createCommunityModalOpenHandler} loading={loading}/>
                <AdminList/>
              </>
              )
            : undefined
          }
        </Box>
      </Drawer>
    )
  }

  const UserActionButtonList = (
      <>
        {authToken
          ? (
            <>
              <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                <IconButton size="small" component={Link} to={'/create-post'}>
                  <AddIcon />
                  <Typography variant='button' sx={{ fontSize: 13 }}>Create</Typography>
                </IconButton>
                <IconButton
                  size="large"
                  aria-label="show notification counts"
                  color="inherit"
                  onClick={openNotificationMenuHandler}
                  aria-controls={openNotificationMenu ? 'notification-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openNotificationMenu ? 'true' : undefined}
                >
                  <Badge badgeContent={unreadNotificationCount} color="error">
                    <NotificationsIcon />
                  </Badge>
                </IconButton>
                <IconButton
                  size="small"
                  color="inherit"
                  onClick={openUserMenuHandler}
                  aria-controls={openTooltip ? 'account-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openTooltip ? 'true' : undefined}
                >
                  {userInfo
                    ? (
                      <ActiveAvatar src={userInfo.avatarImageUrl} />
                      )
                    : (
                      <></>
                      )}
                </IconButton>
              </Box>
              <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                <IconButton
                  size="small"
                  color="inherit"
                  onClick={openUserMenuHandler}
                  aria-controls={openTooltip ? 'account-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openTooltip ? 'true' : undefined}
                >
                  <SearchIcon />
                </IconButton>
                <IconButton size="small" component={Link} to={'/create-post'}>
                  <AddIcon />
                </IconButton>
                <IconButton
                  size="large"
                  aria-label="show notification counts"
                  color="inherit"
                  onClick={openNotificationMenuHandler}
                  aria-controls={openNotificationMenu ? 'notification-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openNotificationMenu ? 'true' : undefined}
                >
                  <Badge badgeContent={unreadNotificationCount} color="error">
                    <NotificationsIcon />
                  </Badge>
                </IconButton>
                <IconButton
                  size="small"
                  color="inherit"
                  onClick={openUserMenuHandler}
                  aria-controls={openTooltip ? 'account-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openTooltip ? 'true' : undefined}
                >
                  {userInfo
                    ? (
                      <ActiveAvatar src={userInfo.avatarImageUrl} />
                      )
                    : (
                      <></>
                      )}
                </IconButton>
              </Box>
            </>
            )
          : (
            <IconButton to="/login" component={Link}>
              <LoginIcon />
              <Typography variant='button'>
                Login
              </Typography>
            </IconButton>
            )}
      </>
  )

  const renderAccountMenu = (
    <Menu
      anchorEl={tooltipAnchorEl}
      id="account-menu"
      open={openTooltip}
      onClose={openUserMenuHandler}
      onClick={closeUserMenuHandler}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: 'visible',
          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          mt: 0,
          '& .MuiAvatar-root': {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1
          },
          '&::before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0
          }
        }
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <MenuItem onClick={closeUserMenuHandler} component={Link} to='/view-profile'>
        {userInfo
          ? (
            <>
              <UserAvatar src={userInfo.avatarImageUrl} />
              <Typography>View Profile</Typography>
            </>
            )
          : (
            <></>
            )}
      </MenuItem>
      <MenuItem onClick={closeUserMenuHandler} disabled>
        <ListItemIcon>
          <FaceOutlinedIcon />
        </ListItemIcon>
        Edit Avatar
      </MenuItem>
      <MenuItem onClick={closeUserMenuHandler} component={Link} to='/settings'>
        <ListItemIcon>
          <Settings fontSize="small" />
        </ListItemIcon>
        Settings
      </MenuItem>
      <Divider />
      <MenuItem onClick={logoutHandler}>
        <ListItemIcon>
          <Logout fontSize="small" />
        </ListItemIcon>
        Logout
      </MenuItem>
    </Menu>
  )

  const renderNotificationMenu = (
    <Menu
      anchorEl={notificationAnchorEl}
      id="notification-menu"
      open={openNotificationMenu}
      onClose={openNotificationMenuHandler}
      onClick={closeNotificationMenuHandler}
      PaperProps={{
        elevation: 0,
        sx: {
          width: '21rem',
          overflow: 'visible',
          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          mt: 0,
          '& .MuiAvatar-root': {
            width: 32,
            height: 32,
            ml: 1,
            mr: 1
          },
          '&::before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0
          }
        }
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
        {notifications?.map(notification => <NotificationListItem key={notification.id} notification={notification} fetchNotifications={fetchNotifications} onDelete={deleteNotificationHandler} />)}
      </List>
      <MenuItem sx={{ justifyContent: 'center' }} component={Link} to="/view-notifications">See All</MenuItem>
    </Menu>
  )

  return (
    <Grid container>
      <AppBar position="fixed" elevation={0} sx={{ borderBottom: '1px solid', borderColor: 'grey.800' }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <LogoWithSideNavBar />
          <AutoCompleteSearchBar />
          {UserActionButtonList}
        </Toolbar>
      </AppBar>
      <Toolbar/>
      {openCreateCommunityModal && <CreateCommunityPage open={openCreateCommunityModal} onClose={createCommunityModalCloseHandler} submitOnSuccess={fetchCommunities} />}
      {renderNotificationMenu}
      {renderAccountMenu}
    </Grid>
  )
}

export default Header
